import { inject, Pipe, PipeTransform } from '@angular/core';
import { CatalogItem } from '@markant-platform/cartridge/model';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'serviceGroupStatus',
  standalone: true,
})
export class ServiceGroupStatePipe implements PipeTransform {
  private translocoService = inject(TranslocoService);
  readonly translationPath = 'catalog.groupState.';

  transform(catalogItem: CatalogItem): string {
    if (catalogItem.isServiceGroup && catalogItem.serviceGroup) {
      const { state, numberBooked } = catalogItem.serviceGroup;

      if (state === 'PARTIAL_BOOKED') {
        const numberOfBooked: 'plural' | 'singular' = numberBooked > 1 ? 'plural' : 'singular';

        return this.translocoService.translate(`${this.translationPath}${state}.${numberOfBooked}`, {
          bookedNumber: numberBooked,
        });
      }

      return this.translocoService.translate(`${this.translationPath}${state}`);
    }
    return '';
  }
}
